

// handle formvalue

// Define the formValues object
var formValues = {
  foot_length: "22.7 cm",
  foot_width: "7.1 cm",
  sneaker_size: "", 
  instep_size: "",
  arch_size: "",
  hallux: "",
  shoe_type: "", 
};



// new range bar

document.addEventListener('DOMContentLoaded', () => {
  const COLOR_TRACK = "#D3D3D3";

  // Get the slider and tooltip for foot length
  const singleSlider = document.querySelector('#singleSlider');
  const singleTooltip = document.querySelector('#singleSliderTooltip');
  const scale = document.getElementById('scale');

  // Predefined values for the slider
  const values = [22.7, 24.3, 26.0, 27.8, 29.5, 31.3, 32.9];
  const MIN = 22.7;
  const MAX = 32.9;

  function updateFootLength(slider, tooltip) {
    const value = parseFloat(slider.value, 10);
    setTooltip(slider, tooltip);
    // Update form value
    formValues.foot_length = `${value} cm`;
    // console.log("Foot Length:", formValues.foot_length);
  }

  function setTooltip(slider, tooltip) {
    const value = slider.value;
    tooltip.textContent = `${value} cm`;
    const thumbPosition = (value - slider.min) / (slider.max - slider.min);
    const percent = thumbPosition * 100;
    const markerWidth = 20; // Width of the marker in pixels
    const offset = (((percent - 50) / 50) * markerWidth) / 2;
    tooltip.style.left = `calc(${percent}% - ${offset}px)`;
  }

  function createScale(values, scale, MIN, MAX) {
    for (let i = 0; i < values.length; i++) {
      const value = values[i];
      const percent = ((value - MIN) / (MAX - MIN)) * 100; // Proper percentage based on MIN/MAX
      const marker = document.createElement('div');
      marker.style.left = `${percent}%`;
      marker.textContent = `${value} cm`;
      scale.appendChild(marker);
    }
  }

  // Events
  if(singleSlider) {
    singleSlider.oninput = () => updateFootLength(singleSlider, singleTooltip);
    setTooltip(singleSlider, singleTooltip);
    
  }

  // Initial load
  if(scale) {
    createScale(values, scale, MIN, MAX); // Scale for foot length
  }
});

// new range bar  for width




document.addEventListener('DOMContentLoaded', () => {
  const COLOR_TRACK = "#D3D3D3";

  // Get the slider and tooltip for foot width
  const singleSlider2 = document.querySelector('#singleSlider2');
  const singleTooltip2 = document.querySelector('#singleSliderTooltip2');
  const scale2 = document.getElementById('scale2');

  // Predefined values for the slider
  const values2 = [7.1, 7.9, 8.7, 9.5, 10.3, 11.1, 11.9, 12.7, 13.5];
  
  const MIN2 = 7.1;
  const MAX2 = 13.5;

  function updateFootWidth(slider, tooltip) {
    const value = parseFloat(slider.value, 10);
    setTooltip(slider, tooltip);
    // Update form value
    formValues.foot_width = `${value} cm`;
    // console.log("Foot Width:", formValues.foot_width);
  }

  function setTooltip(slider, tooltip) {
    const value = slider.value;
    tooltip.textContent = `${value} cm`;
    const thumbPosition = (value - slider.min) / (slider.max - slider.min);
    const percent = thumbPosition * 100;
    const markerWidth = 20; // Width of the marker in pixels
    const offset = (((percent - 50) / 50) * markerWidth) / 2;
    tooltip.style.left = `calc(${percent}% - ${offset}px)`;
  }

  function createScale(values, scale, MIN, MAX) {
    for (let i = 0; i < values.length; i++) {
      const value = values[i];
      const percent = ((value - MIN) / (MAX - MIN)) * 100; // Proper percentage based on MIN/MAX
      const marker = document.createElement('div');
      marker.style.left = `${percent}%`;
      marker.textContent = `${value} cm`;
      scale.appendChild(marker);
    }
  }

  // Events
  if(singleSlider2) {
    singleSlider2.oninput = () => updateFootWidth(singleSlider2, singleTooltip2);
    setTooltip(singleSlider2, singleTooltip2);
    
  }

  // Initial load
  if(scale2) {
    createScale(values2, scale2, MIN2, MAX2); // Scale for foot width
  }
});




// hadle next step 

document.addEventListener("DOMContentLoaded", async function () {
  await getTranslations();
  let steps = document.querySelectorAll(".step"); // All question steps
  let currentStep = 1; // Starting with the first step

  // Initially show the "Find my fit" section and the start button
  if(document.getElementById("initial-fit-section")) {
    document.getElementById("initial-fit-section").style.display = "block";
  }
  if(document.getElementById("startButton")) {
    document.getElementById("startButton").style.display = "block"; 
  

      // When the "Start" button is clicked
      document.getElementById("startButton").addEventListener("click", function () {
          // Hide the initial fit section and start button
        if(document.getElementById("initial-fit-section")) {
          document.getElementById("initial-fit-section").style.display = "none";
        }
          this.style.display = "none"; // Hide the start button
    
          // Show the first step in the quiz
          steps[0].style.display = "block"; 
      });
    }

  async function getSneakerSize(footLength) {
    try {
      let langVal = document.getElementById("shopify_locale")?.value || "en";
                 
        const response = await fetch(`https://lake-cycle-75d4d77a5869.herokuapp.com/public/api/validate-sneaker-size?foot_length=${footLength}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Accept-Language": langVal
            },
        });

        // Check if the response is OK
        if (!response.ok) {
            // Parse the error response body
            const errorData = await response.json();
              return {
                status: false,
                message: errorData.message,
                data: null,
            };
        }

        // Parse the successful response body
        const data = await response.json();

        // Store the relevant data in localStorage
        localStorage.setItem("sneakerSizeSelected", data.data.final);
        localStorage.setItem("sneakerSizeAllowed", data.data.allowed);
        
        // Return both message and data
        return {
            status: true,
            message: data.message,
            data: data.data,
        };
    } catch (error) {
        return {
            status: false,
            message: error.message,
            data: null,
        };
    }
}

  async function getTranslations() {
    try {
      let langVal = document.getElementById("shopify_locale")?.value || "en";
                 
        const response = await fetch(`https://lake-cycle-75d4d77a5869.herokuapp.com/public/api/get-translations`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Accept-Language": langVal
            },
        });

        // Check if the response is OK
        if (!response.ok) {
            // Parse the error response body
            return false;
        }

        // Parse the successful response body
        const data = await response.json();

        localStorage.setItem("errorMessages", JSON.stringify(data.errorMessages));

        // Return both message and data
        return true;
    } catch (error) {
        return false;
    }
}

 $(document).ready(function() {
   
       if (localStorage.getItem('responseData')) {
         $(".fixed-view-your-fit").show();
         $(".fit-banner__message").text("View your perfect fit");
      } else {
         $(".fixed-view-your-fit").hide();
         $(".fit-banner__message").text("Over 80% found their perfect fit using our size tool"); 
      }
   
   
    $(document).on('click', 'a[href="/pages/find-my-fit"]', function(event) {
        event.preventDefault();   // Prevent the default link behavior

        if (localStorage.getItem('responseData')) {
            const langVal = $("#shopify_locale").val() || "en";
            //const redirectUrl = langVal !== "en" ? `/${langVal}/collections/all-products` : "/collections/all-products";
            const redirectUrl = "/collections/all-products";
            // Use setTimeout to ensure the redirect happens smoothly
            setTimeout(function() {
                window.location.href = redirectUrl;
            }, 100);
        } else {
            console.log("No responseData in localStorage. Continue as usual.");
            window.location.href = "/pages/find-my-fit";
        }
    });

   $(document).on('click', '#resetResultPage', function () {
      setTimeout(function() {
         localStorage.removeItem('responseData');
         window.location.href = "/pages/find-my-fit";
      }, 100);
   })
});

  
  // Handle the "Next step" button click
  $(document).ready(function () {

    
    
  $(".nextStepButton").on("click", async function () {
    console.log(formValues);

    let nextStep = parseInt($(this).data("next-step"));
    const footWidth = formValues.foot_width ? parseFloat(formValues.foot_width) : 0;
    const footLength = formValues.foot_length ? parseFloat(formValues.foot_length) : 0;
    const sizeResponse = await getSneakerSize(footLength);
    let errorMessages = JSON.parse(localStorage.getItem("errorMessages"));

    console.log("errorMessages", errorMessages);
    console.log("footWidth", footWidth);
    console.log("footLength", footLength);
    console.log("nextStep", nextStep);

    // Validate form values for each step
    if (nextStep === 4 && (!formValues.sneaker_size || formValues.sneaker_size === "")) {
      alert(errorMessages.select_sneaker_size);
      return;
    } else if (nextStep === 5 && (!formValues.instep_size || formValues.instep_size === "")) {
      alert(errorMessages.select_sneaker_instep);
      return;
    } else if (nextStep === 6 && (!formValues.arch_size || formValues.arch_size === "")) {
      alert(errorMessages.select_sneaker_arch);
      return;
    } else if (nextStep === 7 && (!formValues.hallux || formValues.hallux === "")) {
      alert(errorMessages.select_sneaker_hallux);
      return;
    }

    if (nextStep === 2 && sizeResponse.status === false) {
      alert(sizeResponse.message);
      return;
    }

    if (nextStep === 3) {
      const sneakerSizeVal = localStorage.getItem("sneakerSizeAllowed");
      const sneakerSizeRecommend = localStorage.getItem("sneakerSizeSelected");

      $(".number-grid.shoes_size_class li").each(function () {
        const sizeValue = parseFloat($(this).text().trim());
        if (sizeValue > sneakerSizeVal) {
          const titleMsg = errorMessages.size_not_avail
            .replace("{43}", sneakerSizeVal)
            .replace("{44}", sneakerSizeRecommend);
          $(this).attr("data-title", titleMsg);
        }
      });
    }

    if ($(this).text().trim() === "Show My Results") {
      if (!formValues.shoe_type || formValues.shoe_type === "") {
        alert(errorMessages.select_shoe_type);
        return;
      }

      const postData = formValues;
      const langVal = $("#shopify_locale").val() || "en";

      try {
        $('#loader').fadeIn();
        const response = await fetch("https://lake-cycle-75d4d77a5869.herokuapp.com/public/api/products-filter-new", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Accept-Language": langVal
          },
          body: JSON.stringify(postData)
        });

        if (!response.ok) {
          const errorData = await response.json();
          $('#loader').fadeOut();
          alert(errorData.message);
          return;
        }

        const data = await response.json();
        localStorage.setItem("responseData", JSON.stringify(data.data));
        console.log("Response from server:", data);

        // Reset form elements
        $(".number-grid.shoes_size_class li, .shoes_type li").removeClass("active").css("background-color", "");
        $(".height_instep input[type='radio'], .height_arch input[type='radio'], .radio_yes_no input[type='radio']").prop("checked", false);

        const resetSlider = (slider, tooltip) => {
          const minValue = slider.attr("min");
          slider.val(minValue);
          tooltip.css("left", "0%").text(`${minValue} cm`);
        };

        resetSlider($("#singleSlider2"), $("#singleSliderTooltip2"));
        resetSlider($("#singleSlider"), $("#singleSliderTooltip"));

        formValues = {
          foot_length: "22.7 cm",
          foot_width: "7.1 cm",
          sneaker_size: "",
          instep_size: "",
          arch_size: "",
          hallux: "",
          shoe_type: ""
        };

        //window.location.href = langVal !== "en" ? `/${langVal}/collections/all-products` : "/collections/all-products";
        window.location.href = "/collections/all-products";
      } catch (error) {
        $('#loader').fadeOut();
        console.error("Error fetching data:", error);
        localStorage.setItem("responseData", "");
      }
    } else {
      $('#loader').fadeOut();
      if (nextStep <= steps.length) {
        $(steps[currentStep - 1]).hide();
        $(steps[nextStep - 1]).show();
        currentStep = nextStep;
      }
    }
  });
});


 $(document).ready(function () {
    let sizeListItems = $(".shoes_size_class li");

    sizeListItems.on("mouseenter", function () {
        if (!$(this).hasClass("active")) {
            $(this).css("background-color", "#C7C7C7"); // Light gray on hover
        }
    });

    sizeListItems.on("mouseleave", function () {
        if (!$(this).hasClass("active")) {
            $(this).css("background-color", ""); // Reset to default when not active
        }
    });

    sizeListItems.on("click", function (e) {
        if ($(this).attr("data-title")) {
            e.preventDefault();
            $(".error_msg").html($(this).attr("data-title"));
            //sizeListItems.removeClass("active").css("background-color", ""); // Reset background color
            //formValues.sneaker_size = "";
            //return;
        } else {
            $(".error_msg").html("");
        }

        sizeListItems.removeClass("active").css("background-color", ""); // Reset background color and remove active class from all items
        $(this).addClass("active"); // Add active class to the clicked item
        formValues.sneaker_size = $(this).text().trim(); // Update sneaker_size in formValues
    });
});

$(document).ready(function () {
  // Handle click on .radio-div to check the corresponding radio button and update formValues
  $('.radio-div').on('click', function () {
    $(this).find("input[type='radio']").prop('checked', true);

    formValues.instep_size = $(".height_instep .radio-div input[type='radio']:checked").val();
    formValues.arch_size = $(".height_arch .radio-div input[type='radio']:checked").val();
    formValues.hallux = $(".radio_yes_no .radio-div input[type='radio']:checked").val();
  });

  // Handle radio button change for height_instep, height_arch, and hallux
  $(".height_instep input[type='radio']").on("change", function () {
    if ($(this).is(":checked")) {
      formValues.instep_size = $(this).val();
    }
  });

  $(".height_arch input[type='radio']").on("change", function () {
    if ($(this).is(":checked")) {
      formValues.arch_size = $(this).val();
    }
  });

  $(".radio_yes_no input[type='radio']").on("change", function () {
    if ($(this).is(":checked")) {
      formValues.hallux = $(this).val();
    }
  });

  // Handle shoe type selection with hover and click functionality
  $(".shoes_type li").on({
    mouseenter: function () {
      if (!$(this).hasClass("active")) {
        $(this).css("background-color", "#C7C7C7"); // Light gray on hover
      }
    },
    mouseleave: function () {
      if (!$(this).hasClass("active")) {
        $(this).css("background-color", ""); // Reset background color
      }
    },
    click: function () {
      $(".shoes_type li").removeClass("active").css("background-color", ""); // Reset all items
      $(this).addClass("active"); // Add active class to clicked item
      formValues.shoe_type = $(this).text().trim(); // Update shoe_type in formValues
    }
  });
});


  // Handle the "Back" button click
  document.querySelectorAll(".back_button").forEach(function (button) {
      button.addEventListener("click", function () {
          let previousStep = currentStep - 1;
          if (previousStep >= 1) {
              // Hide the current step
              steps[currentStep - 1].style.display = "none";
              
              // Show the previous step
              steps[previousStep - 1].style.display = "block";
              currentStep = previousStep; // Update the current step index

          } else {
              // If we're on the first step, go back to the initial page
            if(document.getElementById("initial-fit-section")) {
              document.getElementById("initial-fit-section").style.display = "block";
            }
            if(document.getElementById("startButton")) {
              document.getElementById("startButton").style.display = "block"; 
            }
              steps.forEach(function(step) {
                  step.style.display = "none"; // Hide all steps
              });
          }
      });
  });

});

